import { z } from 'zod';
import type { OperationEventsResponse } from './-query/type';
type OperationEventStatus = OperationEventsResponse['items'][number]['status'];
export const Columns = {
  EVENT: 'EVENT',
  ANCHOR_DATE: 'ANCHOR_DATE',
  STEP_PROGRESS: 'STEP_PROGRESS',
  TASK_PROGRESS: 'TASK_PROGRESS',
  STATUS: 'STATUS',
  ACTIONS: 'ACTIONS'
} as const;
export type Columns = (typeof Columns)[keyof typeof Columns];
export const EventStatusValues: Record<OperationEventStatus, OperationEventStatus> = {
  InProgress: 'InProgress',
  Completed: 'Completed',
  Aborted: 'Aborted'
};
export const SearchSchema = z.object({
  pageIndex: z.number().nonnegative().default(0),
  pageSize: z.number().min(1).max(100).default(20),
  status: z.nativeEnum(EventStatusValues).optional(),
  patternId: z.string().min(1).optional(),
  eventTypeId: z.string().min(1).optional()
});